/* eslint-disable prettier/prettier */
export const EMOJIS = {
  thumbsup: '👍',
  thumbsdown: '👎',
  love: '❤️'
}
